import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobNote } from "@/types";

/**
 * This hook is used to remove a job note in the job notes query
 * without refetching the entire query.
 */
export const useRemoveJobNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobNoteId }: { jobNoteId: number }) => {
    queryClient.setQueryData(
      ["job-notes", currentCompanyId, currentJobId],
      (cachedData: JobNote[]) => {
        return cachedData.filter(
          (cachedJobNote: JobNote) => cachedJobNote.id !== jobNoteId,
        );
      },
    );
  };
};
